import { Component } from '@angular/core';
import { BlogService } from '../home/services/blog/blog.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css']
})
export class ArticleComponent {
  constructor(private blogService:BlogService, private route:ActivatedRoute, private router:Router){}
    blog = {
      id: '',
      title: '',
      description: '',
      htmlContent: ''
    }
    ngOnInit(){
      this.blog.id = this.route.snapshot.paramMap.get('id') || '';
      if(this.blog.id)
        this.blogService.getBlogById(this.blog.id).subscribe(res=>{
      this.blog = {
        id:res.blogId,
        title:res.title,
        description:res.description,
        htmlContent:res.htmlContent
      }})
    }

    visitStore(){
      this.router.navigate(['/products']);
    }
}
